import styled, { css } from 'styled-components';

// Mixin para los estilos de tamaño
const sizeStyles = css`
  ${({ $size, theme }) => {
    switch ($size) {
      case 'small':
        return css`
          font-size: ${theme.sizing.sm};
          padding: ${theme.sizing.xxs};
        `;
      case 'large':
        return css`
          font-size: ${theme.sizing.sm};
          padding: ${theme.sizing.sm};
        `;
      default:
        return css`
          font-size: ${theme.sizing.sm};
          padding: ${theme.sizing.xs};
        `;
    }
  }}
`;

// Mixin para los estilos de variantes y estados
const variantStyles = css`
  ${({ $variant, theme }) => {
    switch ($variant) {
      case 'disabled':
        return css`
          background-color: ${theme.fill.defaultWeak};
          border-color: ${theme.border.defaultStrong};
          color: ${theme.colors.defaultSubtle};
          cursor: not-allowed;
          opacity: 0.6;
        `;
      case 'error':
        return css`
          background-color: ${theme.fill.errorBackground};
          border-color: ${theme.border.errorMain};
          color: ${theme.colors.errorMain};
        `;
      default:
        return css`
          background-color: ${theme.fill.defaultMain};
          border-color: ${theme.border.defaultWeak};
          color: ${theme.colors.defaultMain};

          &:hover {
            background-color: ${theme.fill.defaultWeak};
            border-color: ${theme.border.defaultStrong};
          }

          &:active {
            background-color: ${theme.fill.defaultWeak};
            border-color: ${theme.border.inverseMain};
          }

          &::placeholder {
            color: ${theme.colors.defaultWeak};
          }
        `;
    }
  }}
`;

// Input estilizado
const InputTextArea = styled.textarea`
  min-width: 100%;
  max-width: 100%;
  border: 1px solid;
  border-radius: ${({ theme }) => theme.radius.xs};
  font-variant-numeric: lining-nums tabular-nums;
  font-feature-settings: 'ss01' on, 'ss05' on, 'ss06' on, 'ss07' on;
  font-family: MonaSans;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  transition: all 0.3s;

  
  ${sizeStyles} /* Aplicar los estilos basados en el tamaño */
  ${variantStyles} /* Aplicar los estilos basados en la variante */

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  &:focus {
    border: 1px solid ${({ theme }) => theme.border.inverseMain};
    outline: none;
  }
`;

export default InputTextArea;
